<template>
  <div class="wrap">
    <header style=" display: flex;justify-content: center;">
      <span style="position: absolute;left: 20px;" class="iconfont icon-back-left" @click="goBack"></span>
      <h2>{{lang.message}}</h2>
    </header>
    <div class="main">
      <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" ref="loadmore" :auto-fill="false"
        :topPullText="lang.topPullText" :topDropText="lang.dropText" :topLoadingText="lang.loadingText"
        :bottomPullText="lang.bottomPullText" :bottomDropText="lang.dropText" :bottomLoadingText="lang.loadingText">
         <div class="message-list"  @click="readM(index,item.id,item.status)" v-for="(item,index) in messageList"
            :key="index" :class="{'read':item.status==1}">
            <div class="message-title">
              <span>{{types[item.type]}}</span>
              <span class="time">{{item.ctime}}</span>
            </div>
            <div class="message-text">
              <p class="detail">{{item.content}}</p>
              <span class="iconfont icon-back-right"></span>
            </div>
            <div class="details" :class="{'active':readNum==item.id}">
              {{item.content}}
            </div>
          </div>
      </mt-loadmore>
      <div class="no-data" v-if="messageList.length==0">
        <img src="@img/no-data.png" />
        <p>{{lang.nomore}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      return {
        page: 1,
        pageSize: 20,
        pages: 1,
        readNum: '',
        messageList: [],
        types: ''
      }
    },
    computed: {
      ...mapState(['lang'])
    },
    created() {
      this.readArr = [];
      this.page = 1;
      this.getMessage();
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      getMessage() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/user/msg', {
            page: this.page,
            perpg: this.pageSize
          })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              if (this.page == 1) this.messageList = [];
              if(res.data.data){
                this.messageList = this.messageList.concat(res.data.data);
              }
              this.pages = Math.ceil(res.data.totalNum / this.pageSize);
              this.types = res.data.types;
            } else if (res.data.err == 102) {
              this.$router.push('/');
              sessionStorage.setItem('tk', res.data.tk);
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$router.push('/');
          })
      },
      readM(index, id, status) {
        if (this.readNum == id) {
          this.readNum = ''
        } else {
          this.readNum = id
        }
        if (status == 0) {
          this.messageList[index]['status'] = 1;
          this.$doRequest('post', '/user/readMsg', {
              id: id
            })
            .then(res => {
              if (res.data.err == 0) {
                // console.log('已读')
              } else if (res.data.err == 102) {
                this.$router.push('/');
                sessionStorage.setItem('tk', res.data.tk);
              } else {
                this.$messagebox({
                  title: this.lang.tip,
                  message: res.data.msg,
                  confirmButtonText: this.lang.confirm
                });
              }
            })
        }
      },
      loadTop() {
        //下拉刷新
        this.page = 1;
        this.getMessage();
        this.$refs.loadmore.onTopLoaded();
      },
      loadBottom() {
        this.page++;
        if (this.page <= this.pages) {
          this.getMessage();
        } else {
          this.$toast({
            message: this.lang.nomore,
            iconClass: 'iconfont icon-shibai',
            duration: 2000
          })
        }
        this.$refs.loadmore.onBottomLoaded();
      }
    }
  }
</script>

<style >
  .message-list {
    margin: 10px;
    border-radius: 4px;
    padding: 10px 10px 0;
    border: 1px solid #ddd;
    border-left: 3px solid #FF4146;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    background: #fff;

    &.read {
      border-left: 3px solid #41b983;
    }

    .message-title {
      position: relative;
      display: flex;
      padding-bottom: 6px;
      justify-content: space-between;

      .time {
        color: rgba(4, 15, 66, 0.6);
        font-size: 12px;
      }
    }

    .message-text {
      display: flex;
      justify-content: space-between;
      color: rgba(4, 15, 66, 0.6);
      padding-bottom: 10px;

      .message-msg {
        flex: 2;
        overflow: hidden;
        margin-right: 10px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .detail {
        flex: 1;
        text-align: right;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .details {
      max-height: 0;
      transition: all ease .3s;
      color: rgba(4, 15, 66, 0.6);
      padding: 0;
      overflow: hidden;

      &.active {
        max-height: 200px;
        padding: 10px 0;
        border-top: 1px solid #ddd;
      }
    }
  }
</style>